/* eslint-disable react/button-has-type */
import React from 'react';
import classNames from 'classnames';
import {
  node,
  string,
  func,
  shape,
} from 'prop-types';
import { Icon } from 'components/common';

import './FunnelSelectionButton.scss';

const FunnelSelectionButton = ({
  children,
  leftIconName,
  isSelected,
  onClick,
  dataSelectorId,
  dataSelectorValue,
}) => (
  <button
    className={classNames({
      'funnel-selection-button': true,
      selected: isSelected,
    })}
    onClick={onClick}
    data-selector={dataSelectorId}
    data-selector-value={dataSelectorValue}
    data-selector-selected={!!isSelected}
  >
    {leftIconName && (
      <div className="icon-wrapper">
        <Icon medium name={leftIconName} />
      </div>
    )}
    <div>
      {children}
    </div>
  </button>
);

FunnelSelectionButton.propTypes = {
  children: node,
  leftIconName: string,
  isSelected: shape({}),
  onClick: func,
  dataSelectorId: string,
  dataSelectorValue: string,
};

FunnelSelectionButton.defaultProps = {
  children: null,
  leftIconName: null,
  isSelected: null,
  onClick: undefined,
  dataSelectorId: null,
  dataSelectorValue: null,
};

export default FunnelSelectionButton;
